import Duck from 'custom-redux-ducks-ts'

export const notifications = new Duck('notifications', 'eduprivada')
